import { useEffect, useMemo } from "react";

import { useScrollIntoView } from "Venues/utils";
import { useVenueBlockContext, VenueBlockState } from "Bands/contexts";
import { VenueBlockFormProps } from "Bands/containers";

export const useVenueBlockForm = ({
  title: defaultTitle = null,
  venueId: defaultVenueId = null,
  stageId: defaultStageId = null,
  capacityId: defaultCapacityId = null,
}: VenueBlockFormProps) => {
  const {
    currentState,
    setCurrentState,
    query,
    blockTitle,
    venueId,
    stageId,
    capacityId,
    setVenueId,
    setStageId,
    setCapacityId,
  } = useVenueBlockContext();

  const isSearched = useMemo(() => query.query || query.country, [query]);
  const isSubmitDisabled = useMemo(
    () => !venueId || !blockTitle,
    [venueId, blockTitle]
  );

  const goToSearch = () => {
    setCurrentState(VenueBlockState.search);
    setVenueId(null);
    setStageId(null);
    setCapacityId(null);
  };

  const handleCreateVenue = () => {
    setCurrentState(VenueBlockState.createVenue);
  };

  const goBackToSelectedVenue = () => {
    defaultVenueId && setVenueId(defaultVenueId);
    defaultStageId && setStageId(defaultStageId);
    defaultCapacityId && setCapacityId(defaultCapacityId);
  };

  const isVenueDirty = useMemo(
    () =>
      defaultTitle !== blockTitle ||
      defaultVenueId !== venueId ||
      defaultStageId !== stageId ||
      defaultCapacityId !== capacityId,
    [
      blockTitle,
      capacityId,
      defaultCapacityId,
      defaultStageId,
      defaultTitle,
      defaultVenueId,
      stageId,
      venueId,
    ]
  );

  const titleDefaultValues = useMemo(
    () => ({ title: defaultTitle }),
    [defaultTitle]
  );

  // scroll after state change
  const { ref: scrollRef, scrollIntoView } = useScrollIntoView();
  useEffect(() => {
    scrollIntoView();
  }, [scrollIntoView, currentState]);

  return {
    isSearched,
    goToSearch,
    handleCreateVenue,
    isSubmitDisabled,
    scrollRef,
    goBackToSelectedVenue,
    isVenueDirty,
    titleDefaultValues,
  };
};
